// LIB
import React from 'react';
import styled from 'styled-components';

// STYLES
import { colors, fontSize, fontFamily } from '../../Design_System/DesignSystem';

// COMPONENTS
import { Text } from '../atoms/Text';
import { Icon } from '../atoms/Icon';
import { useLanguage } from '../../i18n/LanguageContext';

const Language = () => {
  const { lang, setLang } = useLanguage();
  return (
    <MainLanguage>
      <LangOption onClick={() => setLang('fr')}>
        <Text
          color={colors.tan}
          fontSize={fontSize.small}
          fontFamily={fontFamily.tinos}
          bold={false}
          justify={false}
        >
          <>
            <Icon
              size={fontSize.mini}
              icon={lang === 'fr' ? 'dot' : 'emptyDot'}
              color={colors.tan}
            />{' '}
            <span> </span>
            FR
          </>
        </Text>
      </LangOption>
      <div onClick={() => setLang('en')}>
        <Text
          color={colors.tan}
          fontSize={fontSize.small}
          fontFamily={fontFamily.tinos}
          bold={false}
          justify={false}
        >
          <>
            <Icon
              size={fontSize.mini}
              icon={lang === 'en' ? 'dot' : 'emptyDot'}
              color={colors.tan}
            />{' '}
            <span> </span>
            EN
          </>
        </Text>
      </div>
    </MainLanguage>
  );
};

const MainLanguage = styled.div`
  display: flex;
  position: absolute;
  bottom: 10px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 3;
  cursor: pointer;
`;

const LangOption = styled.div`
  margin-right: 20px;
`;

export default Language;
